import React from 'react';

const PHONE = '9492935721';
const PHONE_DISPLAY = '(949) 293-5721';
const SMS_LINK = `sms:${PHONE}`;
const CALL_LINK = `tel:+1${PHONE}`;

export default function FinalCTA() {
  return (
    <section
      style={{
        padding: '120px 0',
        background: 'var(--mamba-graphite)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Background glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse 80% 60% at 50% 50%, rgba(107,33,168,0.12) 0%, transparent 70%)',
        }}
      />
      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <div className="label-gold mb-6 reveal" style={{ justifyContent: 'center' }}>
          <span style={{ width: '32px', height: '1px', background: 'var(--mamba-gold-light)', display: 'inline-block' }} />
          Get Started
          <span style={{ width: '32px', height: '1px', background: 'var(--mamba-gold-light)', display: 'inline-block' }} />
        </div>

        <h2
          className="section-heading reveal reveal-delay-1"
          style={{ fontSize: 'clamp(32px, 5vw, 60px)', marginBottom: '20px' }}
        >
          Your car is ready.<br />
          <span
            style={{
              background: 'linear-gradient(135deg, var(--mamba-purple-bright), #9333ea 50%, var(--mamba-gold-light))',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            Are you?
          </span>
        </h2>

        <p
          className="reveal reveal-delay-2"
          style={{
            color: 'var(--gray-dim)',
            fontSize: '17px',
            lineHeight: '1.7',
            fontFamily: 'DM Sans, sans-serif',
            marginBottom: '48px',
            maxWidth: '520px',
            margin: '0 auto 56px',
          }}
        >
          Fast response. Transparent pricing. Mobile service to your home or office. Serving Newport Beach, Irvine, and all of Orange County.
        </p>

        <div className="flex flex-wrap gap-4 justify-center reveal reveal-delay-3">
          <a href={SMS_LINK} className="btn-primary">
            <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
            </svg>
            Text for a Quote
          </a>
          <a href={CALL_LINK} className="btn-gold">
            <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.01 1.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z"/>
            </svg>
            Call {PHONE_DISPLAY}
          </a>
        </div>

        <div className="flex flex-wrap gap-8 justify-center mt-12 reveal reveal-delay-4">
          {['We come to you — no drop-off', 'Trusted on luxury & exotic vehicles', "Orange County's detail team"]?.map((item) => (
            <div key={item} className="flex items-center gap-2.5">
              <div style={{ width: '5px', height: '5px', borderRadius: '50%', background: 'var(--mamba-gold-light)', flexShrink: 0 }} />
              <span style={{ color: 'var(--gray-dim)', fontSize: '13px', fontFamily: 'DM Sans, sans-serif' }}>
                {item}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
